<template>
	<div>
		<el-form :model="inputmodel" status-icon :rules="rules" ref="inputmodel" style=" display: grid;
  grid-template-columns: auto auto; grid-column-gap: 0.5rem;grid-auto-flow: row dense;">

			<el-form-item label="房间号" prop="room_num"><br>
				<el-select style="width: 100%;" v-model="inputmodel.room_num" placeholder="请选择房间号"
					v-el-select-loadmore="loadmore" @change="changeselect">
					<el-option v-for=" item in options" :key="item.id" :label="item.room_num" :value="item.room_num">
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item v-for="(item,index) in dialog_span" :key="index" :label="item.name" :prop="item.model">
				<el-input v-model="inputmodel[`${item.model}`]" autocomplete="off"></el-input>
			</el-form-item>
			<el-form-item label="累计" prop="total"><br>
				<span>{{inputmodel.total}}</span>
			</el-form-item>
			<el-form-item label="剩余" prop="residue"><br>
				<span>{{inputmodel.residue}}</span>
			</el-form-item>
			<el-form-item label="阀门" prop="status"><br>
				<el-radio v-model="inputmodel.status" label="0">开闸</el-radio>
				<el-radio v-model="inputmodel.status" label="1">关闸</el-radio>
			</el-form-item>
		</el-form>
		<div class="bottom_button">
			<el-button @click="qx(1)">取 消</el-button>
			<el-button type="primary" @click="qx()">确 定</el-button>
		</div>
	</div>
</template>

<script>
	import {
		house_list,
		energy_edit,
		energy_info,
		water_edit,
		water_info
	} from "@/api/api.js"

	export default {
		directives: {
			'el-select-loadmore': {
				bind(el, binding) {
					const SELECTWRAP_DOM = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap');
					SELECTWRAP_DOM.addEventListener('scroll', function() {
						const condition = this.scrollHeight - this.scrollTop <= this.clientHeight;
						if (condition) {
							binding.value();
						}
					});
				}
			}
		},
		data() {
			return {
				name: '',
				dialog_span: [{
					name: 'IP',
					model: 'ip'
				}, {
					name: '端口号',
					model: 'port'
				}, {
					name: '户号',
					model: 'hunum'
				}, {
					name: '地址',
					model: 'address'
				}, {
					name: '充值',
					model: 'money'
				}],
				inputmodel: {
					rid: '',
					room_num: '',
					ip: '',
					port: '',
					hunum: '',
					address: '',
					money: '',
					status: ''
				},
				rules: {},
				options: [],
				formData: {
					page: 1,
					limit: 10
				},
			}
		},
		props: [
			"item",
			"name"
		],
		methods: {
			qx(i) {
				console.log(this.inputmodel);
				if (i != 1) {

					this.$refs['inputmodel'].validate((valid) => {
						if (valid) {
							let datalist = {
								id: this.inputmodel.id,
								ip: this.inputmodel.ip,
								port: this.inputmodel.port,
								hunum: this.inputmodel.hunum,
								address: this.inputmodel.address,
								money: parseFloat(this.inputmodel.money),
								status: `${this.inputmodel.status}`
							}
							if (this.name == 'Metermanagement') {
								energy_edit(datalist).then(res => {
									this.Messages(res)
									if (res.status == 200) {
										this.inputmodel = {}
										this.$emit('changedia', false)
										this.$parent.$parent.$parent.contractlistcontractlist();
									}
								})
							} else {
								water_edit(datalist).then(res => {
									this.Messages(res)
									if (res.status == 200) {
										this.inputmodel = {}
										this.$emit('changedia', false)
										this.$parent.$parent.$parent.contractlistcontractlist();
									}
								})
							}

						}
					})
				} else {
					// this.inputmodel = {}
					this.$emit('changedia', false)
				}
			},
			loadmore() {
				console.log(this.formData.limit);
				this.formData.page++;
				let sum = this.formData.limit
				// this.formData.limit = sum - (10 * (this.formData.page - 1))
				// if (this.formData.limit >= 0) {
				// this.getList(this.formData);
				// }
				// console.log(this.formData);
			},
			getList(formData) {
				house_list(formData).then(res => {
					const _res = res.data.list
					this.options = [...this.options, ..._res];
				})

			},
			changeselect(value) {
				const selectedItem = this.options.find(item => item.room_num === value);
				if (selectedItem) {
					console.log('Selected item:', selectedItem);
					this.inputmodel.rid = selectedItem.id
				}
			},
			Messages(i) {
				if (i.status == 200) {
					this.$message({
						message: i.msg,
						type: 'success'
					});
				} else {
					this.$message({
						message: i.msg,
						type: 'error'
					});
				}
			},

		},
		created() {
			for (let item in this.inputmodel) {
				this.rules[`${item}`] = [{
					required: true,
					message: '不能为空',
					trigger: 'blur'
				}]
			};
			house_list({
				limit: 0
			}).then(res => {
				const _res = res.data.list
				this.options = _res;
			})
			this.inputmodel = JSON.parse(JSON.stringify(this.item));
			if (this.name == 'Metermanagement') {
				energy_info(this.inputmodel.id).then(res => {
					console.log(res);
					this.inputmodel.residue = res.data.residue
					this.inputmodel.total = res.data.total
					this.inputmodel.status = res.data.status
				})
			} else {
				water_info(this.inputmodel.id).then(res => {
					console.log(res);
					this.inputmodel.residue = res.data.residue
					this.inputmodel.total = res.data.total
					this.inputmodel.status = res.data.status
				})
			}

		},
		watch: {
			item: function(newVal, oldVal) {
				this.inputmodel = JSON.parse(JSON.stringify(this.item));
				if (this.name == 'Metermanagement') {
					energy_info(this.inputmodel.id).then(res => {
						console.log(res);
						this.inputmodel.residue = res.data.residue
						this.inputmodel.total = res.data.total
						this.inputmodel.status = res.data.status
					})
				} else {
					water_info(this.inputmodel.id).then(res => {
						console.log(res);
						this.inputmodel.residue = res.data.residue
						this.inputmodel.total = res.data.total
						this.inputmodel.status = res.data.status
					})
				}
			}
		}
	}
</script>

<style scoped>
	.bottom_button {
		margin: 20px 0;
		display: flex;
		justify-content: center;
	}

	.upload-demo {
		display: flex;
		align-items: center !important;

	}
</style>
<style src="@wangeditor/editor/dist/css/style.css"></style>